import { useCallback, useState } from 'react';

const STORAGE_KEY = 'investor-network-sidebar-expanded';

function readSidebarExpanded() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

function persistSidebarExpanded(expanded) {
    try {
        sessionStorage.setItem(STORAGE_KEY, expanded ? '1' : '0');
    } catch {
        /* ignore quota / private mode */
    }
}

/** Persists investor-network sidebar expand/collapse across route changes and page remounts. */
export function useInvestorNetworkSidebar() {
    const [sidebarExpanded, setSidebarExpandedState] = useState(readSidebarExpanded);
    const sidebarOpen = sidebarExpanded;

    const setSidebarExpanded = useCallback((valueOrUpdater) => {
        setSidebarExpandedState((prev) => {
            const next = typeof valueOrUpdater === 'function' ? valueOrUpdater(prev) : valueOrUpdater;
            persistSidebarExpanded(next);
            return next;
        });
    }, []);

    return { sidebarExpanded, sidebarOpen, setSidebarExpanded };
}
